import { Component, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '../service/theme.service';
import { DistributorsService } from '../service/distributors.service';
import { CognitoService } from '../service/cognito.service';
import { RoleService } from '../service/role.service';
import { formatDate } from '@angular/common';
import { WorkOrderDashboardModalService } from '../service/work-order-dashboard-modal.service';
import { SystemMessageService } from '../service/system-message.service';
import { LocalStorageService } from '../local-storage.service';
import { environment } from '../environments/environment';
import { FilterService } from '../service/filter.service';
import { WorkOrderService } from '../service/work-order.service';

@Component({
    selector: 'app-distributor-work-order-dashboard',
    templateUrl: './distributor-work-order-dashboard.component.html',
    styleUrls: ['./distributor-work-order-dashboard.component.css', '../../global-elements.css'],
    standalone: false
})
export class DistributorWorkOrderDashboardComponent implements OnInit {
  @ViewChild(WorkOrderDashboardModalService) service: any;

  public isLoading = true;
  public ascDesc: number = 0;
  public sortBy: string = '';
  public userFilter: string = '';

  public workOrderArray: any[] = [];
  private originalWorkOrderArray: any[] = [];

  // variables for filter
  public filterBy: string = '';
  public isSortBy: boolean = false;
  public sortOptions = [
    { label: 'workOrderId', value: 'work_order_id' },
    { label: 'workOrderTypeSort', value: 'work_order_type' },
    { label: 'clientcreateFormInputLegalName', value: 'legal_name' },
  ];
  public filterOptions = [
    { label: 'workOrderId', value: 'work_order_id' },
    { label: 'clientcreateFormInputClientName', value: 'legal_name' },
    { label: 'bin', value: 'bin_id' },
    { label: 'iotModalViewDeviceName', value: 'thing_name' },
  ];

  constructor(public theme: ThemeService,
              public distributors: DistributorsService,
              public cognitoService: CognitoService,
              public roleService: RoleService,
              public workOrderModalService: WorkOrderDashboardModalService,
              private systemMessageService: SystemMessageService,
              private localStorageService: LocalStorageService,
              private filter: FilterService,
              private workOrderService: WorkOrderService){

  }

  async ngOnInit() {
    // Call cognito to confirm valid user and get the user type of the current user
    this.cognitoService.confirmValidUser();
    await this.cognitoService.getUserType();

    // Call role service to get the current user roles
    await this.roleService.getRoles();

    this.cognitoService.getCurrentRole(
      [environment.users.role.distributor],
      [environment.users.supplier]
    );

    // Get the local storage message when user create a work order then come back to the list to send him if work order creation was successful or not
    const workOrderCreateMessage = this.localStorageService.getItem('workOrderCreate');
    if(workOrderCreateMessage){
      if(workOrderCreateMessage === 'success'){
        this.systemMessageService.selectRibbon('success', 'createOrderSuccess');
      }else if(workOrderCreateMessage === 'fail'){
        this.systemMessageService.selectRibbon('danger', 'createOrderError');
      }
      this.localStorageService.removeItem('workOrderCreate');
    }

    if(!this.workOrderService.workOrdersArray || this.workOrderService.workOrdersArray.length === 0){
      // Call the function to get all bin model association of the distributor
      await this.workOrderService.getAllEntityWorkOrders(this.cognitoService.distributorId);
    }
    this.workOrderModalService.workOrderArray = this.workOrderService.workOrdersArray;
    this.workOrderModalService.originalWorkOrderArray = this.workOrderService.workOrdersArray;
    this.isLoading = false;
  }

  // Function called when user filter the array
  // search(){
  //   // Set last filter count, filter count and if there's a filter
  //   this.lastFilterCount = this.filterCount;
  //   this.isFilter = this.userFilter.toLowerCase() !== '';
  //   this.filterCount = this.userFilter.length;

  //   let filterProperty = this.filterBy;
  //   if(filterProperty === '' || filterProperty === undefined || filterProperty === null){
  //     filterProperty = 'work_order_id';
  //   }

  //   // Switch if user enter more filter, press backspace or delete filter
  //   switch(true){

  //     case (this.filterCount > this.lastFilterCount):
  //       this.workOrderArray = this.workOrderArray.filter( v => {
  //         if(v[filterProperty] && typeof v[filterProperty] === 'string'){
  //           return v[filterProperty].toLowerCase().includes(this.userFilter.toLowerCase());
  //         }else{
  //           return false;
  //         }
  //       });
  //       this.lastFilterCount = this.filterCount; // Set the count of the user filter
  //       break;

  //     case (this.filterCount < this.lastFilterCount):
  //       this.resetWorkOrderArray(); // Reset the array of bin models
  //       // Filter the array of bin models
  //       this.workOrderArray = this.workOrderArray.filter( v => {
  //         if(v[filterProperty] && typeof v[filterProperty] === 'string'){
  //           return v[filterProperty].toLowerCase().includes(this.userFilter.toLowerCase());
  //         }else{
  //           return false;
  //         }
  //       });
  //       this.lastFilterCount = this.filterCount; // Set the count of the user filter
  //       break;

  //     case (this.isFilter === false):
  //       this.resetWorkOrderArray(); // Reset the array of bin models
  //       this.filterCount = 0;
  //       this.lastFilterCount = 0;
  //       break;
  //   }
  // }

  // Function used to made a search in the list
  search(){
    // Check if there's a filterBy variable and set it to it's default value
    if(this.filterBy === ''){
      this.filterBy = 'thing_name';
    }

    this.workOrderArray = this.filter.search(this.userFilter, this.workOrderModalService.workOrderArray, this.originalWorkOrderArray, this.filterBy);
  }

  // Function called to reset work order array to it's original
  resetWorkOrderArray(){
    this.workOrderArray = [...this.originalWorkOrderArray];
  }

  // Funciton called when user sort the array
  onSortChange(caller: string, event: any){
    // Reset sortBy variable to hide the toggle switch when user press the X in the select
    if(event === undefined){
      this.isSortBy = false;
    }else{
      this.isSortBy = true;
    }

    // Switch the value of ascending or descending
    if(caller === 'switch'){
      if(this.ascDesc === 0){
        this.ascDesc = 1;
      }else{
        this.ascDesc = 0;
      }
    }

    // Avoid sortBy to have no value
    if(this.sortBy === ''){
      this.sortBy = 'work_order_id';
    }

    // Function that sort the list
    this.workOrderArray.sort((a, b) => {
      switch(this.sortBy){
        case 'work_order_id':
          return this.ascDesc === 0 ? b.work_order_id.localeCompare(a.work_order_id) : a.work_order_id.localeCompare(b.work_order_id);

        case 'work_order_type':
          return this.ascDesc === 0 ? b.work_order_type.localeCompare(a.work_order_type) : a.work_order_type.localeCompare(b.work_order_type);

        case 'legal_name':
          return this.ascDesc === 0 ? b.legal_name.localeCompare(a.legal_name) : a.legal_name.localeCompare(b.legal_name);
      }
    });
  }

  // Funciton called when user change work order status
  changeWorkOrderStatus(workOrder: any){
    this.workOrderModalService.changeStatus(workOrder);
  }

  // Function called when user change the deadline date for the work order
  changeWorkOrderDeadlineDate(workOrder: any){
    this.workOrderModalService.changeDeadline(workOrder);
  }

  // Function called when user change the description of the work order
  changeWorkOrderDescription(workOrder: any){
    this.workOrderModalService.changeDescription(workOrder);
  }

  // Function called when user add comments on the work order
  changeWorkOrderComments(workOrder: string){
    // Get the user sub for inserting in work_order_comments table
    const userSub = this.cognitoService.userInfos.attributes.sub;
    // call funciton in the modal service
    this.workOrderModalService.addComment(workOrder, userSub);
  }

  // Function that return column template for the display grid of the list
  getColumnStyle(): any{
    const numberOfColumn = this.ajustNumberOfColumns(this.getScreenWidth());
    if(numberOfColumn){
      if(this.workOrderService.workOrdersArray.length >= numberOfColumn){
        const gridColumns = `repeat(${numberOfColumn}, minmax(0, 325px))`;
        return {
          'grid-template-columns': gridColumns
        };
      }else{
        return {
          'display': `flex`,
          'justify-content': `center`,
          'margin': '0 -10px'
        };
      }
    }
  }

  // Function that return date to format 'dd/MM/yyyy'
  formatDate(date: number){
    return formatDate(date, 'dd/MM/yyyy', 'en-US');
  }

  // Function to get the current screen width
  getScreenWidth(): number {
    // Return the inner width of the window as the screen width
    return window.innerWidth;
  }

  // function called to adjust the number of column of the grid depbending of inner window width
  ajustNumberOfColumns(width: number): number | undefined{
    // Return the floor of the inner page width divided by 450 px as the width of the tile size
    return Math.floor((width / 350) * (90 / 100));
  }
}
